import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { ValidateCode } from "@/shared/ui";
import { AdditionalFlow } from "@/domains/auth/constants/additionalFlow";
import useResetPasswordSmsCode from "@/domains/auth/hooks/reset-password/useResetPasswordSmsCode";
import useGetCodeTimer from "@/domains/auth/hooks/useGetCodeTimer";
import { useAuthFlow } from "@/domains/auth/containers/context";

type Props = {
  address: string;
};

export default function AuthResetPasswordCheckSMSCodeContainer({ address }: Props) {
  const { openOnly } = useAuthFlow();
  const [code, setCode] = useState<string>("");
  const {
    sendCodeHandler,
    sendIsPending,
    sendError,
    checkCodeHandler,
    checkIsPending,
    checkError,
    checkIsCompleted,
  } = useResetPasswordSmsCode();

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    getTimer({ type: "sms", payload: address });
  }, []);

  const onSubmit = useCallback(async () => {
    checkCodeHandler(code);
  }, [checkCodeHandler, code]);

  const onSendCodeHandler = useCallback(async () => {
    if (address) {
      await sendCodeHandler(address);
      await getTimer({ type: "sms", payload: address });
    }
  }, [sendCodeHandler, address]);

  useEffect(() => {
    if (checkIsCompleted) {
      openOnly(AdditionalFlow.AuthUpdatePassword);
    }
  }, [checkIsCompleted, openOnly]);

  return (
    <FocusLock className="contents">
      <ValidateCode
        address={address}
        type={TfaMethod.SMS}
        code={code}
        onCodeChange={setCode}
        onSubmit={onSubmit}
        onSendCode={onSendCodeHandler}
        pending={checkIsPending}
        error={checkError || sendError}
        sendCodePending={sendIsPending}
        timer={timer}
      />
    </FocusLock>
  );
}
